import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const StepWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 3rem 2rem 4rem;
`;

export const ActionButtonStyled = styled(Button)`
  margin: 0 auto;
`;

export const StepSubtitleStyled = styled.p`
  max-width: 80rem;
  margin: 0 auto;
`;
